import React from 'react';
import ReactDOM from 'react-dom';
import { apiService } from '../../common/apiCallService';
import Loading from '../Loading.js';
import { baseUrl, domain } from '../../common/config.js';
import Paper from 'material-ui/Paper';
import Menu from '../Menu.js';
import { withRouter } from 'react-router'
import MediaQuery from 'react-responsive';
import { Redirect } from 'react-router';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import FlatButton from 'material-ui/FlatButton';
import { Link } from 'react-router-dom';
import moment from 'moment';
import * as actions from '../../store/actions/index';
import { connect } from 'react-redux';
import './course.css'
import OnBoard from '../MygameOnBoard/OnBoard'
import { createVirtualPageLoad, closeVirtualPage,updateOnBoard, saveActivity } from '../../common/commonService'
import { getColor, getImage, getTextColor } from '../../common/ThemeService';
import Header from '../../container/Header/Header';

class CourseHome extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      courses: [],
      moduleList: [],
      loading: false,
      isOnBoard: localStorage.getItem('mygame_onboarded') === 'N' ? 1 : 0,
    }
    this.getCourseContent()
  }

  componentDidMount() {
    createVirtualPageLoad("/course")
  }

  componentWillUnmount() {
    closeVirtualPage()
  }

  getCourseContent = () => {
    this.state.loading = true
    this.forceUpdate()
    // this.setState({ loading: true })
    apiService(baseUrl + '/clinic/getCourseContent', {
      "type": 'Course'
    }, (data) => {
      data.courses.map((course, index) => {
        if (!course.order) course.order = 0
        if (data.courses.length != index + 1) course.nextLessonStyle = 'next-prev-active-button'
        else course.nextLessonStyle = 'next-prev-button'
        if (index == 0) course.prevLessonStyle = 'next-prev-button'
        else course.prevLessonStyle = 'next-prev-active-button'
      })
      this.setState({ courses: data.courses })
      this.setState({ loading: false })
    }, (data) => {
      this.setState({ loading: false })
    })
  }
  
  createMarkup = (courseIntro) => { 
    let  courseIntroContent = courseIntro.split(/<\/?(br)[^>]*>/).filter((content) =>
     { return content.trim() != ''})
    let count = 0
    courseIntro = ''
    courseIntroContent.map((content)=>{
      if(content == 'br') count ++
      if(count <= 4){
        if(content == 'br')
        courseIntro= courseIntro.concat('</br>');
        else
        courseIntro= courseIntro.concat(content);
        if(count == 4) count++
      }
    })
    return {__html:courseIntro}; 
  };

  disableOnBoard = async () => {
    this.setState({ loading: true, isOnBoard: 0 })
    await updateOnBoard()
    this.setState({ loading: false })
  }

  render() {
    this.props.setHeaderTitle('Course')
    const themeColor = getColor()
    const themeTextColor = getTextColor()
    return (
        <div className='course-page'>
          {this.state.isOnBoard ==1 && JSON.parse(localStorage.getItem('userRole')).indexOf('PLAYER') != -1  && <OnBoard  disableOnBoard={this.disableOnBoard}/>}
          {this.state.loading ? <Loading /> : null}
          {localStorage.getItem('token') && <Header/>}
          {this.state.courses.map((course, index) => {
            return (
              index % 2 === 0
                ? <div key={index} style={{ background: 'linear-gradient(180deg, #FFFFFF 0%, #F2F2F2 100%)', minHeight: "371px" }}>
                <div className="container">
                <div className="row" key={index} >
                  <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 course-content" style={{paddingLeft:'25px'}}>
                    <h2 className='course-header' style={{marginTop:'60px'}}> Learn {course.contentName}</h2>
                    <div dangerouslySetInnerHTML={this.createMarkup(course.courseIntro)}></div>
                    <button data-e2e="learnEnter" style={{ outline: 0, border: 'none', backgroundColor: themeColor, color: themeTextColor }} className='course-button' 
                    onClick={() => {
                      this.props.history.push({
                      pathname: `/course/${course.contentName}`,
                      state: { activeCourse:course, courseList: this.state.courses },
                    })
                      saveActivity({
                        hit_page: 'Courses',
                        hit_type: 'learn_fundamentals',
                      })
                    }
                    }>ENTER</button>
                      
                  </div>
                  <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6" style={{ padding: '0' }}>
                    <center>
                      <img className='course-img-resp'
                        src={"//" + domain + getImage("/images/common/course/","/clinicMobileMockUp.png")} />  </center>
                  </div>
                </div>
                </div>
                </div>
                :
                <div key={index} style={{ backgroundColor: 'white' }}>
                <div className="container">
                 <div className="row"  id="small-device-display">
                  <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6" id="lap-img" style={{ padding: '0' }}>
                    <img className='course-imglap-resp' src={"//" + domain + getImage("/images/common/course/", "/clinicLaptop.png")} />
                  </div>
                  <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 next-course" id="lap-col" key={index} >
                    <h2 className='course-header' style={{marginTop:'60px'}}>Explore {course.contentName}</h2>
                    <div dangerouslySetInnerHTML={this.createMarkup(course.courseIntro)}></div>
                        <button data-e2e="exploreEnter" style={{ outline: 0, border: 'none', backgroundColor: themeColor, color: themeTextColor }} className='course-button' 
                        onClick={() => {                 
                        this.props.history.push({
                        pathname: `/course/${course.contentName}`,
                        state: { activeCourse:course, courseList: this.state.courses },
                        })
                        saveActivity({
                          hit_page: 'Courses',
                          hit_type: 'Explore_Clinic',
                          })
                      }
                    }
                    >ENTER</button>
                  </div>
                </div>
                </div>
                </div>
            )
          })}
        </div>
    )
  }
}

const mapDispatchToProps = dispatch => {
  return {
    setHeaderTitle : ( newTitle ) => dispatch(actions.setHeaderTitle( newTitle ))
  }
};

export default connect(null, mapDispatchToProps)(CourseHome);


/** WEBPACK FOOTER **
 ** ./src/components/NewCourse/CourseHome.js
 **/